import React from 'react';

const SvgMm = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="MM_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="MM_svg__b" fill="#fff">
        <use xlinkHref="#MM_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#MM_svg__a" />
      <path fill="#F13D4F" mask="url(#MM_svg__b)" d="M0 13.333h28V20H0z" />
      <path fill="#4AC94B" mask="url(#MM_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path fill="#FFD043" mask="url(#MM_svg__b)" d="M0 0h28v6.667H0z" />
      <path
        fill="#FFF"
        mask="url(#MM_svg__b)"
        d="M14 12.34l-3.527 2.514 1.302-4.13-3.481-2.578 4.33-.04L14 4l1.375 4.107 4.331.039-3.48 2.577 1.3 4.131z"
      />
    </g>
  </svg>
);

export default SvgMm;
